module.exports = __webpack_public_path__ + "iphone-home@2x-684a24109a5f52026c37448dabbe45c3.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/img/iphone-home@2x.png
// module id = 372
// module chunks = 0